import { z } from 'zod/v4';

/**
 * Response body for `POST /integrations/amfori/sync` (the manual "Sync now"
 * trigger). Returns the id of the freshly-created `amfori_sync_history` run so
 * the caller can correlate it with the eventual completion notification.
 */
export const SyncNowResponseSchema = z
  .object({
    syncHistoryId: z.string(),
  })
  .strict();

export type SyncNowResponse = z.infer<typeof SyncNowResponseSchema>;
